import { useEffect } from 'react';

const interceptOpen = (link: string) => {
  // a 태그 새창으로 여는 경우 window.open으로 변경해주기 (동일 session으로 묶음)
  window.open(link, '_blank');
};

const handleClickEvent = (event: MouseEvent) => {
  let target = event.target as HTMLLinkElement;
  while (target?.tagName) {
    if (target.tagName === 'A' && (target.target === '_blank' || event.metaKey || event.shiftKey || event.ctrlKey)) {
      event.preventDefault();
      interceptOpen(target.href);
      break;
    }
    target = target.parentNode as HTMLLinkElement;
  }
};

export const useInterceptLink = (isClientView?: boolean) => {
  useEffect(() => {
    const clearListener = () => {
      document.removeEventListener('click', handleClickEvent);
    };

    if (isClientView) {
      document.addEventListener('click', handleClickEvent);
    } else {
      clearListener();
    }
    return clearListener;
  }, [isClientView]);
};
